import React, {useState} from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import {Slots} from '../../Slots';

const Description = ({
  data,
  isBusy,
  onDelete,
  onEvent,
  onTransfer,
  onUpdate,
  onClose,
  fetchData
}) => {

  const [path, setPath] = useState('root');

  return isBusy
    ? <CircularProgress/>
    : <Grid container justify='space-around' align='center'>
      <Grid item xs={12}>
        <Slots
          {...{
            fetchData,
            path,
            setPath,
          }}
        />
      </Grid>
      {data.status === 'enrolled' &&
      <Grid item>
        <Button color='primary' onClick={onUpdate}>
          Completar
        </Button>
      </Grid>
      }
      <Grid item>
        <Button color='primary' onClick={onEvent}>
          Evento
        </Button>
      </Grid>
      <Grid item>
        <Button color='primary' onClick={onDelete}>
          Apagar
        </Button>
      </Grid>
      {data.vehicleId !== 'none' &&
      <Grid item>
        <Button color='primary' onClick={onTransfer}>
          Transferir
        </Button>
      </Grid>
      }
      <Grid item>
        <Button color='secondary' onClick={onClose}>
          Fechar
        </Button>
      </Grid>
    </Grid>;
};

export default Description;
